import React, { useState } from 'react';
import API from '../api/api';
import Swal from 'sweetalert2'; // ✅ Import SweetAlert2
import { useNavigate } from 'react-router-dom';
import "./AdminSignup.css";

const AdminSignup = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
    securityQuestion: "",
    securityAnswer: ""
  });

  const [errors, setErrors] = useState({
    phone: "",
    email: "",
    password: ""
  });

  const questions = [
    "What is the name of your first pet?",
    "What is the name of your favorite teacher in school?",
    "What city were you born in?",
    "What is your favorite childhood nickname?",
    "What is your mother's maiden name?"
  ];

  // ✅ Validations
  const validatePhone = (value) => {
    setErrors(prev => ({ ...prev, phone: /^\d{10}$/.test(value) ? "" : "Phone must be exactly 10 digits" }));
  };

  const validateEmail = (value) => {
    setErrors(prev => ({ ...prev, email: value.endsWith("@gmail.com") ? "" : "Email must end with @gmail.com" }));
  };

  const validatePassword = (value) => {
    setErrors(prev => ({ ...prev, password: value.length < 4 ? "Password must be at least 4 characters" : "" }));
  };

  // ✅ Submit new admin (only for Super Admin)
  const submit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("eseva_token");

    try {
      const confirmed = await Swal.fire({
        title: "Create New Admin?",
        text: "This will register a new admin account with these details.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#fe6e03",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Yes, Create",
      });

      if (!confirmed.isConfirmed) return;

      const res = await API.post("/admin/signup", form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      await Swal.fire({
        icon: "success",
        title: "✅ Admin Created Successfully!",
        text: `New admin "${res.data.admin.name}" registered.`,
        confirmButtonColor: "#fe6e03",
        timer: 1800,
        showConfirmButton: false,
      });

      navigate("/admin");
    } catch (err) {
      console.error("Signup Error:", err);

      Swal.fire({
        icon: "error",
        title: "❌ Signup Failed",
        text:
          err.response?.data?.message ||
          "Unable to register new admin. Please check details or permissions.",
        confirmButtonColor: "#d33",
      });
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-card shadow-lg">
        <h3 className="text-center mb-4 heading">Create Admin Account</h3>

        <form onSubmit={submit}>
          <input
            className="form-control input-box mb-3"
            placeholder="Full Name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            required
          />

          <input
            type="number"
            className="form-control input-box mb-1"
            placeholder="Phone Number"
            value={form.phone}
            onChange={(e) => {
              setForm({ ...form, phone: e.target.value });
              validatePhone(e.target.value);
            }}
            required
          />
          {errors.phone && <p className="text-danger small">{errors.phone}</p>}

          <input
            className="form-control input-box mb-1"
            placeholder="Email Address"
            value={form.email}
            onChange={(e) => {
              setForm({ ...form, email: e.target.value });
              validateEmail(e.target.value);
            }}
            required
          />
          {errors.email && <p className="text-danger small">{errors.email}</p>}

          <input
            type="password"
            className="form-control input-box mb-1"
            placeholder="Password"
            value={form.password}
            onChange={(e) => {
              setForm({ ...form, password: e.target.value });
              validatePassword(e.target.value);
            }}
            required
          />
          {errors.password && <p className="text-danger small">{errors.password}</p>}

          <label className="form-label mt-3">Select Security Question</label>
          <select
            className="form-control input-box mb-3"
            value={form.securityQuestion}
            onChange={(e) => setForm({ ...form, securityQuestion: e.target.value })}
            required
          >
            <option value="">-- Select a Question --</option>
            {questions.map((q, i) => (
              <option key={i} value={q}>{q}</option>
            ))}
          </select>

          <input
            className="form-control input-box mb-3"
            placeholder="Your Answer"
            value={form.securityAnswer}
            onChange={(e) => setForm({ ...form, securityAnswer: e.target.value })}
            required
          />

          <button
            className="btn signup-btn w-100"
            type="submit"
            disabled={errors.phone || errors.email || errors.password}
          >
            Register Admin
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminSignup;
